import { Switch } from "@/components/ui/switch";
import Field from "./Field";
import PhotoControl from "./PhotoControl";

export default function ProductPanel({ product, onChange, onUpload, onRemove }) {
  const set = (key) => (value) => onChange({ ...product, [key]: value });
  return (
    <div className="st-panel-body" data-testid="product-panel">
      <PhotoControl image={product.image} onUpload={onUpload} onRemove={onRemove} testPrefix="product-photo" />
      <label className="st-toggle">
        <Switch checked={product.include} onCheckedChange={set("include")} data-testid="product-include-switch" />
        <span>
          <b>{product.include ? "Inclus în catalog" : "Mutat în runda 2"}</b>
          <small>Dezactivează dacă produsul nu are încă poză finală.</small>
        </span>
      </label>
      <div className="st-grid-2">
        <Field label="Preț salon fără TVA (se afișează cu TVA)" value={product.price} onChange={set("price")} testId="product-price-input" hint="Ex: 129 lei" big />
        <Field label="Cod produs" value={product.code} onChange={set("code")} testId="product-code-input" hint="Apare discret" big />
      </div>
      <Field label="Denumire" value={product.name} onChange={set("name")} testId="product-name-input" />
      <div className="st-grid-2">
        <Field label="Volum" value={product.size} onChange={set("size")} testId="product-size-input" />
        <Field label="Gamă" value={product.line} onChange={set("line")} testId="product-line-input" />
      </div>
      <Field label="Etichetă" value={product.category} onChange={set("category")} testId="product-category-input" />
    </div>
  );
}
